import { createContext, useState, ReactNode, Dispatch, SetStateAction, useContext, useEffect } from "react"

import { MainModule, Module } from "../type_interface/SettingType";
import { MainRouteType, RouteType } from "../modules/auth/AuthMenu";

interface MasterDataProviderProps {
    children: ReactNode;
}

interface MasterDataState {
    mainModuleList: MainModule[],
    moduleList: Module[],
    permissionList: MainRouteType[],
    actionList: RouteType[],
    updatePermission: number,
    isPermissionLoaded: boolean,
}

interface MasterDataContextType {
    masterData: MasterDataState;
    // setMasterData: Dispatch<SetStateAction<MasterDataState>>;
    setMainModuleList: (list: MainModule[]) => void;
    setModuleList: (list: Module[]) => void;
    setPermissionList: (list: MainRouteType[]) => void;
    setActionList: (list: RouteType[]) => void;
    updatePermission: () => void;
}


const initialState: MasterDataState = {
    mainModuleList: [],
    moduleList: [],
    permissionList: [],
    actionList: [],
    updatePermission: 0,
    isPermissionLoaded: false,
}

const MasterDataContext = createContext<MasterDataContextType>({
    masterData: initialState,
    // setMasterData: () => {},
    setMainModuleList: () => { },
    setModuleList: () => { },
    setPermissionList: () => { },
    setActionList: () => { },
    updatePermission: () => { },
})

export const MasterDataProvider = ({ children }: MasterDataProviderProps) => {

    const [masterData, setMasterData] = useState(initialState);

    const updatePermission = () => {
        setMasterData(state => ({ ...state, updatePermission: state.updatePermission + 1, isPermissionLoaded: false }));
    }

    const setMainModuleList = (list: MainModule[]) => {
        setMasterData(state => ({ ...state, mainModuleList: list }))
    }

    const setModuleList = (list: Module[]) => {
        setMasterData(state => ({ ...state, moduleList: list }))
    }

    const setPermissionList = (list: MainRouteType[]) => {
        setMasterData(state => ({ ...state, permissionList: list, isPermissionLoaded: true }))
    }

    const setActionList = (list: RouteType[]) => {
        setMasterData(state => ({ ...state, actionList: list, isPermissionLoaded: true }))
    }
   
    return (
        <MasterDataContext.Provider
            value={{
                masterData,
                setMainModuleList, setModuleList,
                setPermissionList, setActionList, 
                updatePermission,
            }}>
            {children}
        </MasterDataContext.Provider>
    )

}

export const useMasterData = () => {
    return useContext(MasterDataContext);
}